import React from 'react'

const City = () => {
  return (
    <div className='w-100 text-dark bg-light h-25'>City</div>
  )
}

export default City